<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-indecx-surfey></app-indecx-surfey>
<app-chat-bot></app-chat-bot>
<div class="container py-4">
  <!-- ROW 1 - CARD 1 LINHA -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="row">
          <div class="col-9">
            <app-breadcrumb></app-breadcrumb>
            <h1 class="titulo">Painel de Controle</h1>
            <!-- DIV 4 CARDS ATALHOS -->
            <div class="row">
              <!-- CARD FAZER PEDIDO -->
              <div class="col">
                <button
                  [tag]="addTagManagerInteraction('card:box:click', 'importar-dados-fazer-pedidos')"
                  class="card-atalho"
                  routerLink="/importador-dados"
                  id="fazerPedido"
                  >
                  <h3 class="titulo-atalho">REALIZAR<br>PEDIDOS</h3>
                  <img class="mb-2" src="/assets/img/dados.png" alt="dados" width="44px">
                  <p class="descricao-atalho">Página para realizar pedidos.</p>
                </button>
              </div>
              <!-- CARD PEDIDOS -->
              <div class="col">
                <button
                  [tag]="addTagManagerInteraction('card:box:click', 'listar-pedidos')"
                  class="card-atalho"
                  routerLink="/listar-pedidos"
                  id="listarPedidos">
                  <h3 class="titulo-atalho">LISTAR<br>PEDIDOS</h3>
                  <img class="mb-2" src="/assets/img/lista-pedidos.png" alt="Pedidos" width="53px">
                  <p class="descricao-atalho">Lista de pedidos realizados.</p>
                </button>
              </div>
              <!-- CARD CARGOS -->
              <div class="col">
                <button
                  [tag]="addTagManagerInteraction('card:box:click', 'demonstrativo-de-faturas')"
                  class="card-atalho"
                  routerLink="/demonstrativos-faturas"
                  id="demonstrativosFaturas">
                  <h3 class="titulo-atalho">DEMONSTRATIVO DE<br>FATURAS</h3>
                  <img class="mb-2" src="/assets/img/demonstrativo-faturas.png" alt="lista de faturas " width="50px">
                  <p class="descricao-atalho">Lista de notas fiscais para os pedidos realizados.</p>
                </button>
              </div>
              <!-- CARD LISTA USUÁRIOS -->
              <div class="col">
                <button [tag]="addTagManagerInteraction('card:box:click', 'lista-de-usuarios')"
                  class="card-atalho"
                  routerLink="/usuario-beneficio"
                  id="usuarioBeneficio">
                  <h3 class="titulo-atalho">LISTA DE<br>USUÁRIOS</h3>
                  <img class="mb-2" src="/assets/img/lista-usuarios.png" alt="lista de usuarios " width="50px">
                  <p class="descricao-atalho">Listagem de usuários que utilizam os benefícios.</p>
                </button>
              </div>
            </div>
          </div>
          <button class="col-3 border-0 bg-transparent" [tag]="addTagManagerInteraction('banner:button:click', 'saiba-mais')">
            <img src="/assets/img/propaganda-home.png" alt="propaganda" width="100%" alt="">
          </button>
        </div>

      </div>
    </div>
  </div>
  <!-- ROW 2 - CARD 2 LINHA -->
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <h1 class="titulo">Histórico</h1>

        <table class="table table-hover border-bottom mt-4" aria-describedby="tabela que lista o historico de importacoes">
          <caption>Tabela com histórico de importações</caption>
          <thead>
            <tr>
              <th scope="col">Pedido</th>
              <th scope="col">Emissão</th>
              <th scope="col">Valor Total</th>
              <th scope="col">Pagamento</th>
              <th scope="col">Entrega</th>
            </tr>
          </thead>
          <tbody>
            @for (historico of historicoPedidos; track historico) {
              <tr>
                <td>{{historico.idPedido}}</td>
                <td>{{historico.dataEmissao | appDate: 'dd/MM/yyyy'}}</td>
                <td>{{historico.valorTotalItens | currency:"BRL":"symbol"}}</td>
                <td>{{historico.dataPagamento | appDate: 'dd/MM/yyyy'}}</td>
                <td>{{historico.dataEntrega | appDate: 'dd/MM/yyyy'}}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <app-auto-readjustment-contract></app-auto-readjustment-contract>
  <!-- ROW 3 - CARD 3 LINHA -->
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <div class="input-group w-25 float-end align-items-center">
          <input type="text" class="form-control sombra" (keyup.enter)="buscaNoticias()" [(ngModel)]="inputBusca" placeholder="Buscar Comunicado"
            [tag]="addTagManagerInteraction('box:search:click', 'buscar-comunicado')">
          @if (inputBusca) {
            <button
              (click)="buscaNoticias()"
              class="btn-icon"
              >
              <i class="fa fa-search c-primary icone-lupa" aria-hidden="true"></i>
            </button>
          }
          @if (!inputBusca) {
            <i class="fa fa-search c-primary icone-lupa" aria-hidden="true"></i>
          }
        </div>
        <h1 class="titulo">Informativo Alelo</h1>
        <p class="paragrafo mb-4">Resumo das informações, notícias e configurações de atalho</p>

        @if (noticias && noticias.length > 0) {
          <div class="row">
            @for (noticia of noticias; track noticia) {
              <div class="col-4 pe-4">
                <h4 class="titulo-noticia">{{noticia.resumoNoticia}}</h4>
                <p class="descricao-noticia">{{noticia.descAssuntoNoticia}}</p>
                <span class="data-noticia"><i class="fa fa-calendar me-2" aria-hidden="true"></i>{{noticia.dataDaNoticia | appDate: 'dd/MM/yyyy'}}</span>
                <button
                  [tag]="addTagManagerInteraction('select:link:click', 'veja-mais')"
                  class="veja-mais-noticia"
                  (click)="detalharNoticias(noticia.idNoticia)"
                  >
                  Veja mais
                </button>
              </div>
            }
            <div class="col-12 mt-4"><button [tag]="addTagManagerInteraction('box:button:click', 'ver-todas-as-noticias')" class="botao-outline w-100" routerLink="/noticias">VER TODAS AS NOTÍCIAS</button></div>
          </div>
        }

        @if (noticias === null) {
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <output class="spinner-border c-primary">
                  <span class="visually-hidden">Consultando notícias ...</span>
                </output>
              </div>
              <p class="legenda-spinner">Consultando notícias ...</p>
            </div>
          </div>
        }

        @if (!noticias?.length && noticias !== false) {
          <div class="text-center">
            <img src="/assets/img/vazio.png" alt="representando que nenhuma notícia foi encontrada" width="230px">
            <p class="legenda-vazio">Nenhuma notícia encontrada.</p>
          </div>
        }

        @if (noticias === false) {
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <img src="/assets/img/erro.png" width="230px" alt="erro">
                <p class="legenda-erro">Ocorreu um erro na consulta das notícias.</p>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
